
import en_app from "../locale/en/app.json";
import en_validate from "../locale/en/validate.json";
import ja_app from "../locale/ja/app.json";

const en = { ...en_app, ...en_validate };
const ja = { ...ja_app };

export const fallback = "en";

export const supportedLocales = {
  en: {
    name: "English",
    translationFileLoader: () => en,
    // translationFileLoader: () => require('../locale/en.json'),

    // en is default locale in Moment
    momentLocaleLoader: () => Promise.resolve(),
  },
  ja: {
    name: "Japanese",
    translationFileLoader: () => ja,
    // translationFileLoader: () => require('../locale/ja.json'),
    momentLocaleLoader: () => import("moment/locale/ja"),
  },
};

// export const defaultNamespace = "app";

// export const namespaces = [
//     "app",
// ];

//   "app": {
//         "おかえりなさい": "Welcome back"
//     },
